import script from "./IfreamIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./IfreamIndex.vue?vue&type=script&setup=true&lang=js"

import "./IfreamIndex.vue?vue&type=style&index=0&id=5df6f0c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df6f0c8"]])

export default __exports__